import * as React from 'react';
import { classes } from '../../helpers';
import { elevationCss } from '../../helpers/elevations';
import { useTheme } from '../Theme/Theme';
import { list as style } from './style';
export const List = (props) => {
    var _a, _b;
    const { elevation = 2 } = props;
    const theme = useTheme();
    const css = style(props.densed, props.backgroundColor || theme.background);
    return (React.createElement("div", null,
        React.createElement("ul", { className: classes(elevationCss(elevation), props.className, css), style: props.style }, Array.isArray(props.children)
            ? (_a = props.children) === null || _a === void 0 ? void 0 : _a.map((v, i) => v &&
                React.cloneElement(v, {
                    key: `item-${i}`,
                    gutter: (props.densed && [0, '6px 8px 6px 9px']) || v.props.gutter,
                }))
            : React.cloneElement(props.children || React.createElement("div", null), {
                gutter: (props.densed && [0, '6px 8px 6px 9px']) || ((_b = props.children) === null || _b === void 0 ? void 0 : _b.props.gutter),
            }))));
};
//# sourceMappingURL=List.js.map